export default () => {
  const triggerSelector = '.filter--heading';
  document.addEventListener('click', (event) => {
    const { target } = event;
    const btn = target.closest(triggerSelector);
    if (btn) {
      event.preventDefault();
      btn.parentElement.classList.toggle('is-active');
      if (btn.parentElement.classList.contains('is-active')) {
        btn.setAttribute('aria-expanded', 'true');
      } else {
        btn.setAttribute('aria-expanded', 'false');
      }
    }
  });
};
